const AUTH_CACHE_KEY = 'reef_auth_cache';

function parseCache(raw) {
  if (!raw) return null;
  try {
    const data = JSON.parse(raw);
    const user = data?.user;
    if (!user || !user.id) return null;
    return user;
  } catch {
    return null;
  }
}

/** Read cached user from localStorage (remember me) or sessionStorage. */
export function readCachedAuth() {
  if (typeof window === 'undefined') return null;
  return parseCache(localStorage.getItem(AUTH_CACHE_KEY)) || parseCache(sessionStorage.getItem(AUTH_CACHE_KEY));
}

export function isPersistentAuthCache() {
  if (typeof window === 'undefined') return false;
  return Boolean(localStorage.getItem(AUTH_CACHE_KEY));
}

/** Persist user snapshot for fast hydration on reload (not a security token). */
export function saveAuthCache(user, persistent = false) {
  if (typeof window === 'undefined' || !user) return;
  const payload = JSON.stringify({ user, savedAt: Date.now() });
  if (persistent) {
    localStorage.setItem(AUTH_CACHE_KEY, payload);
    sessionStorage.removeItem(AUTH_CACHE_KEY);
  } else {
    sessionStorage.setItem(AUTH_CACHE_KEY, payload);
    localStorage.removeItem(AUTH_CACHE_KEY);
  }
}

export function clearAuthCache() {
  if (typeof window === 'undefined') return;
  localStorage.removeItem(AUTH_CACHE_KEY);
  sessionStorage.removeItem(AUTH_CACHE_KEY);
}
